import { format } from 'date-fns';
import { TFunction } from 'i18next';
import { UnitsEnum } from '../../../services/entities/impl/blfApi/apiConstants';

/**
 * Creates an export file name based on the provided table name, units, and translation function.
 *
 * @param tableName - The name of the table to be included in the file name.
 * @param units - The units of measurement, either metric or imperial.
 * @param t - The translation function used to localize the units label.
 * @returns The formatted export file name.
 */
export const createExportFileName = (
  tableName: string,
  t: TFunction<'translation', undefined>,
  units?: UnitsEnum
): string => {
  const formattedDate = format(new Date(), 'yyyy-MM-dd_HH-mm a');

  const unitsLabel = t(units === UnitsEnum.metric ? 'Metric' : 'Imperial');

  return `${t(tableName)} - ${t('Units')}_${unitsLabel} - ${t(
    'Downloaded'
  )}_${formattedDate}`;
};
